import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import ScrollToTop from "@/components/ScrollToTop";
import { CartProvider } from "@/context/CartContext";
import { CookieConsentProvider } from "@/context/CookieConsentContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <CookieConsentProvider>
        <CartProvider>
          <ScrollToTop />
          <App />
        </CartProvider>
      </CookieConsentProvider>
    </Router>
  </React.StrictMode>
);
